import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

const now = new Date()

export const useMonthPeriodStore = create(
  persist(
    set => ({
      year: now.getFullYear(),
      month: now.getMonth() + 1,
      setYear: year => set({ year }),
      setMonth: month => set({ month }),
    }),
    {
      name: 'month-period',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
)
